import React, { useEffect, useContext, useState } from 'react';
import { MobXProviderContext, observer } from 'mobx-react';
import { SatCoreRegister } from '../SatCoreRegistry';
import ReactHtmlParser from 'react-html-parser';
import { Loader } from 'semantic-ui-react';

import Auth from '../managers/AuthManager';

import '../css/TermsOfUse.less';

const TermsOfUse = observer(() => {

  const { contextHelpManager } = useContext(MobXProviderContext);

  const [termsOfUse, setTermsOfUse] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    
    const fetchTermsOfUse = async () => {
      const publisherSatelliteCode = Auth.publisherSatelliteCode;
      const contextHelpId = `${publisherSatelliteCode}_TERMS_OF_USE`;
      if (!contextHelpManager.contextHelpMap.has(contextHelpId)) {
        await contextHelpManager.fetchContextHelp(contextHelpId);
      }
      const termsOfUse = contextHelpManager.contextHelpMap.get(contextHelpId);
      setTermsOfUse(termsOfUse);
      setIsLoading(false);
    };
    fetchTermsOfUse();
  }, []);

  useEffect(() => {
    if (termsOfUse === null) return;
    
    if (!termsOfUse) {
      window.history.back();
    }
  }, [termsOfUse]);

  if (isLoading) {
    return (
      <div className='centered-loader'>
        <Loader active inline='centered' />
      </div>
    );
  }

  return termsOfUse ? (
    <div className='terms-of-use'>
      <div className='terms-of-use-title'>Terms of Use</div>
      <div className='terms-of-use-body'>
        {ReactHtmlParser(termsOfUse)}
      </div>
    </div>
  ) : (
    <div className='terms-of-use'>
      No Terms of Use found
    </div>
  );
});

export default TermsOfUse;
SatCoreRegister('TermsOfUse', TermsOfUse);